import { SettingsInputComponent } from '@mui/icons-material'
import { Box, Skeleton } from '@mui/material'
import { AvcInstanceSdiThumbnail } from '@nativewaves/nw-cloud-sdk/content'

export const SdiDialogImage = ({ isLoading, data, url, format }: AvcInstanceSdiThumbnail) => {
  if (isLoading) {
    return <Skeleton variant="rectangular" sx={{ width: 432, height: 243, mb: 2 }} />
  }

  if (!url && !data) {
    return <SettingsInputComponent sx={{ width: 432, height: 243, mb: 2, display: 'block' }} fontSize="large" />
  }

  return (
    <Box
      sx={{ width: 432, height: 243, objectFit: 'contain', mb: 2, display: 'block' }}
      component="img"
      src={url || `data:image/${format};base64,${data}`}
      alt="SDI Thumbnail"
    />
  )
}

export const SdiImage = ({ isLoading, data, url, format }: AvcInstanceSdiThumbnail) => {
  if (isLoading) {
    return <Skeleton variant="rectangular" sx={{ width: 50, height: 35, mb: 2 }} />
  }

  if (!url && !data) {
    return <SettingsInputComponent sx={{ width: 35, height: 35, mb: 2 }} fontSize="large" />
  }

  return (
    <Box
      sx={{ width: 'auto', height: 35, objectFit: 'contain', mb: 2 }}
      component="img"
      src={url || `data:image/${format};base64,${data}`}
      alt="SDI Thumbnail"
    />
  )
}
